export enum LobActivityActivitiesPerimissions {
  Activities = 'activities',
  MyStudents = 'my-students',
  Search = 'search',
  Registrations = 'registrations',
  Sort = 'sort',
}
